import React from 'react';

import { AssessmentLibrary } from 'components/common/libraries';

type AssessmentsProps = {
  programId: number;
  lessonId?: number;
  unitId?: number;
};

const Assessments = ({ programId, lessonId, unitId }: AssessmentsProps) => (
  <AssessmentLibrary
    lessonId={lessonId}
    programId={programId}
    unitId={unitId}
  />
);

export default Assessments;
